// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.index-page {
    padding: 20px;
    text-align: center;
}

.aide-de-jeux {
    margin-bottom: 10vh;
    margin-right: 200px;
    margin-left: 200px;
}

.index-links {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;
    /* Adjust the gap between items if needed */
    font-size: 1.5em;
}

.index-links a {
    text-decoration: none;
    /* color: inherit; */
    /* Inherits the color from the parent element */
}

.index-links span {
    margin: 0 10px;
}

section {
    margin-top: 50px;
    padding: 20px;
    border: 1px solid #ccc;
    background-color: #f9f9f9;
    border-radius: 5px;
}

section h2 {
    margin-top: -20px;
    padding-top: 20px;
}

/* src/css/AideDeJeu.css */
.index-links span {
    margin: 0 10px;
}

.book-chapter {
    margin-bottom: 20px;
}

/* Style commun aux deux boutons */
.btn {
    display: inline-block;
    font-size: 16px;
    font-family: 'Arial', sans-serif;
    font-weight: bold;
    border: 2px solid black;
    border-radius: 20px;
    text-align: center;
    cursor: pointer;
    transition: background-color 0.3s, color 0.3s;
    text-decoration: none;
}

.btn-chapter {
    min-width: 150px;
}

.btn-page {
    min-width: 110px;
}

/* Style pour le bouton 'btn-in' */
.btn.btn-in {
    background-color: #d2aa6d;
    /* couleur beige dorée */
    color: #030303;
    border-color: #030303;
}
.modal-indices .btn.btn-in:hover {
    background-color: #F3ECD2;
    color: #DE9709;
    border-color: #DE9709;
}

/* Style pour le bouton 'btn-out' */
.btn.btn-out {
    background-color: #030303;
    color: #d2aa6d;
    border-color: #d2aa6d;
    /* couleur beige dorée */
}
.modal-indices .btn.btn-out:hover {
    background-color: #030303;
    color: #F3ECD2;
    border-color: #d2aa6d;
    /* couleur beige dorée */
}

/* Effets au survol */
.btn-in:hover,
.btn-out:hover {
    /* opacity: 1; */
}

.chapitre-buttons div, .page-buttons div, .livre-buttons div {
    gap:10px;
}
.modal-indices {
    border: 2px solid #F3ECD2;
    padding: 40px 30px;
    background-color: #DAB166;
    width: 50%;
    margin: 20px auto;
    text-align: center;
    border-radius: 5px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
.modal-indices h3 {
    color:#F3ECD2;
    margin-bottom:25px;
}
.modal-indices .btn {
    color:#F3ECD2;
}
.modal-indices p {
    color:#F3ECD2;
    font-weight: 600;
}
.hr-indices {
    border: 2px solid white;
    width: 160px;
    margin: 10px auto;
}

#encre-invisible {
    margin-top:30px;
}
#encre-invisible h2 {
    color:#F3ECD2;
}
#encre-invisible .btn {
    margin:5px auto 15px;
}

/* Responsive */
@media (max-width:992px) {
    .aide-de-jeux {
        margin-bottom: 5vh;
        margin-right: 50px;
        margin-left: 50px;
    }

    .modal-indices {
        width:75%;
    }
}

@media (max-width:767px) {
    .aide-de-jeux {
        margin-bottom: 5vh;
        margin-right: 0;
        margin-left: 0;
    }

    .modal-indices {
        width:100%;
        padding:20px;
    }
}`, "",{"version":3,"sources":["webpack://./src/css/AideDeJeu.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,2CAA2C;IAC3C,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,oBAAoB;IACpB,+CAA+C;AACnD;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA,0BAA0B;AAC1B;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,kCAAkC;AAClC;IACI,qBAAqB;IACrB,eAAe;IACf,gCAAgC;IAChC,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,6CAA6C;IAC7C,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA,kCAAkC;AAClC;IACI,yBAAyB;IACzB,wBAAwB;IACxB,cAAc;IACd,qBAAqB;AACzB;AACA;IACI,yBAAyB;IACzB,cAAc;IACd,qBAAqB;AACzB;;AAEA,mCAAmC;AACnC;IACI,yBAAyB;IACzB,cAAc;IACd,qBAAqB;IACrB,wBAAwB;AAC5B;AACA;IACI,yBAAyB;IACzB,cAAc;IACd,qBAAqB;IACrB,wBAAwB;AAC5B;;AAEA,qBAAqB;AACrB;;IAEI,gBAAgB;AACpB;;AAEA;IACI,QAAQ;AACZ;AACA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;IACzB,UAAU;IACV,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,wCAAwC;AAC5C;AACA;IACI,aAAa;IACb,kBAAkB;AACtB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;IACb,gBAAgB;AACpB;AACA;IACI,uBAAuB;IACvB,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;AACA;IACI,aAAa;AACjB;AACA;IACI,oBAAoB;AACxB;;AAEA,eAAe;AACf;IACI;QACI,kBAAkB;QAClB,kBAAkB;QAClB,iBAAiB;IACrB;;IAEA;QACI,SAAS;IACb;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,eAAe;QACf,cAAc;IAClB;;IAEA;QACI,UAAU;QACV,YAAY;IAChB;AACJ","sourcesContent":[".index-page {\n    padding: 20px;\n    text-align: center;\n}\n\n.aide-de-jeux {\n    margin-bottom: 10vh;\n    margin-right: 200px;\n    margin-left: 200px;\n}\n\n.index-links {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 20px;\n    /* Adjust the gap between items if needed */\n    font-size: 1.5em;\n}\n\n.index-links a {\n    text-decoration: none;\n    /* color: inherit; */\n    /* Inherits the color from the parent element */\n}\n\n.index-links span {\n    margin: 0 10px;\n}\n\nsection {\n    margin-top: 50px;\n    padding: 20px;\n    border: 1px solid #ccc;\n    background-color: #f9f9f9;\n    border-radius: 5px;\n}\n\nsection h2 {\n    margin-top: -20px;\n    padding-top: 20px;\n}\n\n/* src/css/AideDeJeu.css */\n.index-links span {\n    margin: 0 10px;\n}\n\n.book-chapter {\n    margin-bottom: 20px;\n}\n\n/* Style commun aux deux boutons */\n.btn {\n    display: inline-block;\n    font-size: 16px;\n    font-family: 'Arial', sans-serif;\n    font-weight: bold;\n    border: 2px solid black;\n    border-radius: 20px;\n    text-align: center;\n    cursor: pointer;\n    transition: background-color 0.3s, color 0.3s;\n    text-decoration: none;\n}\n\n.btn-chapter {\n    min-width: 150px;\n}\n\n.btn-page {\n    min-width: 110px;\n}\n\n/* Style pour le bouton 'btn-in' */\n.btn.btn-in {\n    background-color: #d2aa6d;\n    /* couleur beige dorée */\n    color: #030303;\n    border-color: #030303;\n}\n.modal-indices .btn.btn-in:hover {\n    background-color: #F3ECD2;\n    color: #DE9709;\n    border-color: #DE9709;\n}\n\n/* Style pour le bouton 'btn-out' */\n.btn.btn-out {\n    background-color: #030303;\n    color: #d2aa6d;\n    border-color: #d2aa6d;\n    /* couleur beige dorée */\n}\n.modal-indices .btn.btn-out:hover {\n    background-color: #030303;\n    color: #F3ECD2;\n    border-color: #d2aa6d;\n    /* couleur beige dorée */\n}\n\n/* Effets au survol */\n.btn-in:hover,\n.btn-out:hover {\n    /* opacity: 1; */\n}\n\n.chapitre-buttons div, .page-buttons div, .livre-buttons div {\n    gap:10px;\n}\n.modal-indices {\n    border: 2px solid #F3ECD2;\n    padding: 40px 30px;\n    background-color: #DAB166;\n    width: 50%;\n    margin: 20px auto;\n    text-align: center;\n    border-radius: 5px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n.modal-indices h3 {\n    color:#F3ECD2;\n    margin-bottom:25px;\n}\n.modal-indices .btn {\n    color:#F3ECD2;\n}\n.modal-indices p {\n    color:#F3ECD2;\n    font-weight: 600;\n}\n.hr-indices {\n    border: 2px solid white;\n    width: 160px;\n    margin: 10px auto;\n}\n\n#encre-invisible {\n    margin-top:30px;\n}\n#encre-invisible h2 {\n    color:#F3ECD2;\n}\n#encre-invisible .btn {\n    margin:5px auto 15px;\n}\n\n/* Responsive */\n@media (max-width:992px) {\n    .aide-de-jeux {\n        margin-bottom: 5vh;\n        margin-right: 50px;\n        margin-left: 50px;\n    }\n\n    .modal-indices {\n        width:75%;\n    }\n}\n\n@media (max-width:767px) {\n    .aide-de-jeux {\n        margin-bottom: 5vh;\n        margin-right: 0;\n        margin-left: 0;\n    }\n\n    .modal-indices {\n        width:100%;\n        padding:20px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
